import { ActionTypes } from "../constantes/ActionTypes";
import axios from "../../../../common/axios";

export const soldeStart = (action) => {
  return (dispatch) => {
    dispatch(action);
    axios
      .get(
        `/getSolde`
      )
      .then((response) => {
        dispatch(soldeSuccess(response.data));
      })
      .catch((error) => {
        dispatch(soldeFailed(error.response?.data));
      });
  };
};

export const soldeSuccess = (data) => {
  return {
    type: ActionTypes.ACTION_SOLDE_SUCCESS,
    payload: data,
  };
};

export const soldeFailed = (error) => {
  return {
    type: ActionTypes.ACTION_SOLDE_FAILED,
    payload: error,
  };
};

export const shipmentInfoInit = () => {
  return {
    type: ActionTypes.ACTION_PORTS_INIT,
    payload: "",
  };
};
